module.exports = __webpack_public_path__ + "img/proposal2.3040ad25.png";